import type { MeResponse } from "../api";
import { logout } from "../api";

interface TilesPageProps {
  me: MeResponse;
  onLoggedOut: () => void;
}

export default function TilesPage({ me, onLoggedOut }: TilesPageProps) {
  async function handleLogout() {
    await logout();
    onLoggedOut();
  }

  function handleTileClick(firmId: string) {
    // Echter Redirect (kein fetch!) -- die Firmen-Instanz muss das SSO-Cookie
    // in einer echten Navigation setzen koennen.
    window.location.href = `/go/${firmId}`;
  }

  return (
    <div className="tiles-page">
      <header className="tiles-header">
        <div>
          <h1>Fortuna Softec</h1>
          <p className="subtitle">Willkommen, {me.userName || me.username}</p>
        </div>
        <button type="button" className="secondary-button" onClick={handleLogout}>
          Abmelden
        </button>
      </header>

      {me.firms.length === 0 ? (
        <p className="empty-state">
          Fuer diesen Account sind aktuell keine Firmen freigeschaltet. Bitte an die
          Administration wenden.
        </p>
      ) : (
        <div className="tiles-grid">
          {me.firms.map((firm) => (
            <button
              key={firm.id}
              type="button"
              className="firm-tile"
              onClick={() => handleTileClick(firm.id)}
            >
              <img src={firm.logoPath} alt={`${firm.name} Logo`} className="firm-logo" />
              <span className="firm-name">{firm.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
